import React from "react";
import { Form, Col } from "react-bootstrap";
import { ApplicantContainer} from "../unstated/applicant";
import { apiURL } from "../config/common";
import { useHistory } from "react-router-dom";

export default function SchRegisterStatus() {

  const history = useHistory();

    function handleClick(path) {
        
        history.push("/not-enrol");
    }

  let app = ApplicantContainer.useContainer();
  
  if( app.scholarshipChosen) {
    return (
        app.showSchRegisterStatus ?
        <>
        <Form.Row>
          <Col xs={12}>        
              <Form.Group as={Col} controlId="frScholarship" htmlFor="frScholarship">
              <Form.Label>This scholarship is applicable to Sunway registered students only. Have you enrolled into the programme?</Form.Label>      
                <div>
                    <Form.Check inline label="Yes" value="yes" name="registerstatus" id="registerstatusyes" type="radio" required />
                    {/* <Form.Check inline label="No" value="no" name="registerstatus" id="registerstatusno" type="radio" onChange={() => window.location.assign('/not-enrol')} required /> */}
                    <Form.Check inline label="No" value="no" name="registerstatus" id="registerstatusno" type="radio" onClick={handleClick} required />
                </div>
              </Form.Group>
          </Col>
        </Form.Row>
        </>
        :
        <></>
        );
  }else{
    return (<></>);
  }  
}

